import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '@layout/sidebar/sidebar.component';

@Component({
  selector: 'app-phishing-shell',
  templateUrl: './phishing-shell.component.html',
  styleUrls: ['./phishing-shell.component.scss'],
  imports: [SidebarComponent, RouterOutlet],
})
export class PhishingShellComponent {}
